const removeSociedad = usersList => {
  const users = Array.from(usersList);

  return users.filter(user => user.name !== "Sociedad");
};

export { removeSociedad };
